<template>
  <transition name="slide">
    <section class="area-slider">
      <div class="slider-destaques">
        <a v-if="sliders.length > 1" class="botao-nav" id="anterior" @click="voltarSlider">&lsaquo;</a>
        <a v-if="sliders.length > 1" class="botao-nav" id="proximo" @click="avancarSlider">&rsaquo;</a>

        <form class="paginacao" v-if="sliders.length > 1">
          <div v-for="(itens, indice) in sliders" :key="indice">
            <input
              type="radio"
              name="slider-paginas"
              @click="trocarSlider(indice)"
              :checked="checagem(indice)"
            />
            <label for="test1"></label>
          </div>
        </form>

        <div id="slider-1" v-if="sliders.length > 0">
          <!-- <div class="conteudo">
            <h1>Conteúdos Vivo. Para você ficar por dentro de todas as novidades!</h1>
            <a :href="sliders[sliderAtual].link" class="botao">
              <span class="texto">CONTINUAR LENDO</span>
              <span>&rsaquo;</span>
            </a>
          </div>
          <div class="fundo-gradiente"></div>-->
          <keep-alive>
            <img
              v-if="sliders && sliders.length > 0"
              :src="sliders[sliderAtual].imagem"
              alt="Destaques Vivo"
              class="slider-fundo"
              @click="goToPage(sliders[sliderAtual].link, sliders[sliderAtual].tab)"
              @mouseover="stopSlider"
              @mouseleave="startSlider"
            />
          </keep-alive>
        </div>

        <div id="slider-mobile" v-if="sliders.length > 0">
          <!-- <div class="conteudo">
            <h1>Conteúdos Vivo. Para você ficar por dentro de todas as novidades!</h1>
            <a :href="sliders[sliderAtual].link" class="botao-mobile">
              <span>&rsaquo;</span>
            </a>
          </div>
          <div class="fundo-mobile"></div>-->
          <img
            v-if="sliders.length > 0"
            :src="sliders[sliderAtual].imagem"
            alt="Destaques Vivo"
            class="slider-fundo"
          />
        </div>
      </div>
    </section>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { validateUrl } from '../../../helpers/helpers';

let interval = null;

export default {
  name: 'MainSlider',
  data() {
    return {
      tempo: 5000,
      stopTime: false,
      sliderAtual: 0,
    };
  },
  computed: {
    ...mapGetters({
      sliders: 'midia/principal',
      userUF: 'user/uf',
    }),
  },
  methods: {
    ...mapActions({
      getMidiaPrincipal: 'midia/getMidiaPrincipal',
    }),
    onTap(e) {
      console.log(e);
    },
    startSlider() {
      interval = setInterval(() => {
        this.avancarSlider();
      }, this.tempo);
    },
    stopSlider() {
      clearInterval(interval);
    },
    avancarSlider() {
      const tamanho = this.sliders.length - 1;
      if (this.sliderAtual == tamanho) {
        this.sliderAtual = 0;
      } else {
        this.sliderAtual += 1;
      }
    },
    voltarSlider() {
      const tamanho = this.sliders.length - 1;
      if (this.sliderAtual == 0) {
        this.sliderAtual = tamanho;
      } else {
        this.sliderAtual -= 1;
      }
    },
    trocarSlider(indice) {
      this.sliderAtual = indice;
      this.tempo = 5000;
    },
    goToPage(e, tab) {
      if (!e) return;

      const openTab = !!+tab;
      const url = validateUrl(e)
        ? e
        : e === '/' || e === ''
        ? window.location.origin
        : `https://${e}`;

      document.body.removeAttribute('style');

      if (openTab) window.open(url, '_self');
      else {
        window.open(url, '_blank');
      }
    },
    checagem(indice) {
      if (indice === this.sliderAtual) {
        return true;
      }
      return false;
    },
  },
  beforeMount() {
    // get data
    this.getMidiaPrincipal();
  },
  mounted() {
    this.$nextTick(() => {
      if (this.sliders.length > 1) this.startSlider();
    });
  },
  beforeDestroy() {
    this.stopSlider();
  },
  watch: {
    userUF(after) {
      if (after) {
        this.getMidiaPrincipal();
        setTimeout(() => {
          if (this.sliders.length > 1) this.startSlider();
        }, 500);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

.area-slider {
  padding-top: 85px;
}

.slider-destaques {
  @extend %area-de-utilizacao;
  @extend %nao-selecionavel;
  @extend %gradiente_twilight;
  width: 980px;
  height: 325px;
  position: relative;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  border-radius: 5px;
  -webkit-box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.4);
  -moz-box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.4);
  box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.4);
  z-index: 1;

  & .conteudo {
    @extend %flex;
    @extend %direction-column;
    @extend %justify-center;
    @extend %align-items-start;
    @extend %nao-selecionavel;
    position: absolute;
    left: 10%;
    max-width: 38%;
      font-family: 'VivoType';
    font-weight: bold;
    height: 325px;
    z-index: 10;

    & h1 {
      margin: 0px;
      text-align: left;
      font-size: 42px;
      line-height: 48px;
      max-width: 100%;
      color: white;
      letter-spacing: 0px;
    }

    & .botao {
      @extend %flex;
      @extend %justify-between;
      @extend %align-items-center;
      cursor: pointer;
      color: #fff;
      width: 200px;
      background-color: $cor_primaria;
        font-family: 'VivoType';
      font-weight: bold;
      font-size: 17px;
      padding: 10px 20px;
      border-radius: 10px;
      margin-top: 20px;
      border-left: 10px solid $cor_secundaria;
      letter-spacing: 0.1vmax;
      text-decoration: none;
      z-index: 10;
      transition: all 0.2s ease-in-out;

      &:hover {
        color: $cor_primaria !important;
        background-color: $cor_secundaria !important;
        text-decoration: none !important;
      }

      & span {
        margin: 0px;
        padding: 0px;
        line-height: 1em;
      }
    }
  }

  & .fundo-gradiente {
    border-radius: 5px 0 0 5px;
    background: #660099; /* Old browsers */
    background: -moz-linear-gradient(
      -45deg,
      #660099 0%,
      #660099 30%,
      #cd1e5a 60%,
      #cd1e5a 100%
    ); /* FF3.6-15 */
    background: -webkit-linear-gradient(
      -45deg,
      #660099 0%,
      #660099 30%,
      #cd1e5a 60%,
      #cd1e5a 100%
    ); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(
      135deg,
      #660099 0%,
      #660099 30%,
      #cd1e5a 60%,
      #cd1e5a 100%
    ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#660099', endColorstr='#CD1E5A',GradientType=1 ); /* IE6-9 */
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1;
    -webkit-clip-path: polygon(64% 0, 53% 46%, 50% 100%, 0 100%, 0 0);
    clip-path: polygon(64% 0, 53% 46%, 50% 100%, 0 100%, 0 0);
  }

  & .fundo-mobile {
    display: none;
  }

  & .botao-nav {
    z-index: 1000;
    font-size: 50px;
    margin: 0px;
    position: absolute;
    top: 40%;
    padding: 20px 20px 30px 20px;
    line-height: 10px;
    @extend %nao-selecionavel;
    -webkit-text-shadow: -2px 0 white, 0 2px white, 2px 0 white, 0 -2px white;
    -moz-text-shadow: -2px 0 white, 0 2px white, 2px 0 white, 0 -2px white;
    text-shadow: -2px 0 white, 0 2px white, 2px 0 white, 0 -2px white;
    color: $cor_primaria;
    transition: all 0.1s ease-in-out;
    cursor: pointer;

    &:hover {
      transform: scale(1.15);
    }

    &:nth-child(1) {
      left: 0;
    }

    &:nth-child(2) {
      right: 0;
    }
  }

  & .paginacao {
    @extend %flex;
    @extend %direction-row;
    @extend %justify-center;
    @extend %align-items-end;
    @extend %nao-selecionavel;
    position: absolute;
    bottom: 0;
    width: 100%;
    z-index: 1001;
    margin-bottom: 30px;

    & [type='radio']:checked,
    [type='radio']:not(:checked) {
      position: relative;
      left: 17px;
      bottom: -14px;
      z-index: 1;
      width: 1.3rem;
      height: 1.3rem;
      opacity: 0;
    }
    & [type='radio']:checked + label,
    [type='radio']:not(:checked) + label {
      position: relative;
      padding-left: 0px;
      cursor: pointer;
      line-height: 20px;
      display: inline-block;
      color: #666;
    }
    & [type='radio']:checked + label:before,
    [type='radio']:not(:checked) + label:before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 6px;
      height: 6px;
      border: 1px solid white;
      border-radius: 100%;
      background: $cor_primaria_40;
    }
    & [type='radio']:checked + label:after,
    [type='radio']:not(:checked) + label:after {
      content: '';
      width: 12px;
      height: 12px;
      background: $cor_primaria;
      border: 1px solid white;
      position: absolute;
      top: -3px;
      left: -2px;
      border-radius: 100%;
      -webkit-transition: all 0.2s ease;
      transition: all 0.2s ease;
    }
    & [type='radio']:not(:checked) + label:after {
      opacity: 0;
      -webkit-transform: scale(0);
      transform: scale(0);
    }
    & [type='radio']:checked + label:after {
      opacity: 1;
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }

  & .mascara-vivo {
    @extend %nao-selecionavel;
    z-index: 10;
    position: absolute;
    top: 0;
    height: 100%;
    right: 0;

    & img {
      border-radius: 0px 5px 4px 0px !important;
    }
  }

  & .mascara-gradiente {
    @extend %nao-selecionavel;
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 1;
    border-radius: 5px;
    background: -moz-linear-gradient(
      top,
      rgba(102, 0, 153, 0) 0%,
      rgba(102, 0, 153, 0.6) 50%,
      rgba(102, 0, 153, 0.6) 100%
    ); /* FF3.6-15 */
    background: -webkit-linear-gradient(
      top,
      rgba(102, 0, 153, 0) 0%,
      rgba(102, 0, 153, 0.6) 50%,
      rgba(102, 0, 153, 0.6) 100%
    ); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(
      to bottom,
      rgba(102, 0, 153, 0) 0%,
      rgba(102, 0, 153, 0.6) 50%,
      rgba(102, 0, 153, 0.6) 100%
    ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00660099', endColorstr='#80660099',GradientType=0 ); /* IE6-9 */
  }

  & #slider-1 {
    position: absolute;
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
    height: 325px;
    width: 980px;

    & img {
      width: 100%;
      border-radius: 5px;
    }
  }

  & #slider-mobile {
    display: none;
  }

  & .slider-fundo {
    float: right;
    max-width: 100%;
    height: 100%;
    @extend %nao-selecionavel;
    object-fit: cover;
    cursor: pointer !important;
  }
}

@media all and (min-width: 300px) and (max-width: 1000px) {
  .area-slider {
    padding-top: 110px;
    margin-top: -35px;
    margin-bottom: 0px;
  }

  .slider-destaques {
    // overflow: hidden;
    width: calc(100% - 0px);
    height: calc(((100vh + 100vw) * 10) / 90);
    border-radius: 0px;
    -webkit-box-shadow: 0px 7px 27px rgba(0, 0, 0, 0.4);
    -moz-box-shadow: 0px 7px 27px rgba(0, 0, 0, 0.4);
    box-shadow: 0px 7px 27px rgba(0, 0, 0, 0.4);

    & .botao-nav {
      color: transparent;
      text-shadow: none;
      padding: 0px;
      font-size: 0px;
      width: 15%;
      top: 5%;
      height: 90%;
    }

    & .paginacao {
      align-items: center;
      bottom: 0;
      margin-bottom: -20px;
      margin-right: -5%;
      transform: scale(0.5);
      margin-left: -2vw;
    }

    & #slider-1 {
      display: none;
    }

    & #slider-mobile {
      position: absolute;
      -webkit-transition: all 0.3s ease;
      transition: all 0.3s ease;
      display: block;
      width: 100%;
      height: 100%;

      & .conteudo {
        flex-direction: row;
        align-items: center;
        padding: 2% 8%;
        background: #660099; /* Old browsers */
        background: -moz-linear-gradient(
          -45deg,
          #660099 0%,
          #660099 20%,
          #cd1e5a 100%
        ); /* FF3.6-15 */
        background: -webkit-linear-gradient(
          -45deg,
          #660099 0%,
          #660099 20%,
          #cd1e5a 100%
        ); /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(
          135deg,
          #660099 0%,
          #660099 20%,
          #cd1e5a 100%
        ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#660099', endColorstr='#CD1E5A',GradientType=1 ); /* IE6-9 */
        left: 0;
        bottom: 0;
        max-width: 100%;
        // min-height: 45px;
        border-radius: 0 0 15px 15px;
        height: auto;

        & h1 {
          font-size: calc(((100vh + 100vw) / 100) + 5px);
          line-height: 1.25em;
          padding-right: 10%;
        }

        & .botao-mobile {
          cursor: pointer;
          border-radius: 5px;
          font-size: calc(((100vh + 100vw) / 100) + 15px);
          line-height: calc(((100vh + 100vw) / 100) + 0px);
          margin-right: -8%;
          padding: 6%;
          color: white;
        }
      }

      & .fundo-mobile {
        display: block;
      }

      & .slider-fundo {
        max-width: 100%;
        height: 100%;
        width: 100vw;
        border-radius: 0px;
        cursor: pointer !important;
      }
    }
  }
}

@media all and (min-width: 680px) and (max-width: 1000px) {
  .area-slider {
    padding-top: 110px;
    margin-top: -10px;
    margin-bottom: 50px;
  }

  .slider-destaques {
    height: calc(((100vh + 100vw) * 10) / 68);

    & .paginacao {
      margin-bottom: -25px;
    }
  }
}
</style>
